import React from "react";

const Icon = ({ name, className }) => (
  <svg className={`icon -${name} ${className || ""}`}>
    <use xlinkHref={`#svg_${name}`} />
  </svg>
);

export default Icon;
